<footer class="footer">
<div class="section-inner">
<div class="footer-top">
<div class="footer-brand">
<a routerLink="/" (click)="scrollToTop()" class="brand" aria-label="CircledPlus home">
<img class="brand-logo" src="/cir-home/images/circledplus-logo.svg" alt="CircledPlus" width="156" height="40"/>
</a>
<p>Discover Exceptional Homes. Know Their Worth. Circled Plus offers independent, paid advisory services distinct from sales.</p>

<div class="footer-contact">
<a href="tel:+918069069715">080 6906 9715</a>
<a href="mailto:support@circled.co.in">support&#64;circled.co.in</a>
<span>5th Block, HBR Layout, Service Road, Outer Ring Rd, Bengaluru, Karnataka 560043</span>
</div>
</div>
<nav class="footer-links" aria-label="Footer navigation">
<a routerLink="/search">Explore Homes</a>
<a routerLink="/pricing">Membership plans</a>
<a routerLink="/" fragment="intelligence">Circled Intelligence (CI)</a>
<a href="https://blogs.circledplus.com/">Market Insights</a>
<a routerLink="/for-nri">For NRIs</a>
<a routerLink="/" fragment="methodology">Our Methodology</a>
<a routerLink="/aboutus">About CircledPlus</a>
<a routerLink="/contactus">Contact</a>
<a routerLink="/" fragment="newsletter">Newsletter</a>
</nav>
</div>
<p class="footer-registration">Karnataka RERA No: PRM/KA/RERA/1251/309/AG/171110/000701<br/>Telangana RERA No: A28200003211</p>
<div class="footer-bottom">
<span>© 2026 CircledPlus. All rights reserved.</span>
<div class="footer-legal">
<a routerLink="/termsandcondition">Terms &amp; Conditions</a>
<a routerLink="/privacypolicy">Privacy Policy</a>
<a routerLink="/contactus">Refunds &amp; service-fee enquiries</a>
<span>Bangalore, India</span>
</div>
</div>
</div>
</footer>
